import { orange } from "@ant-design/colors"
import { faCalendar } from "@fortawesome/pro-duotone-svg-icons"
import { faClock } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DatePicker, Space, Tooltip } from "antd"
import dayjs from 'dayjs'
import { useState } from "react"
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export type Props = {
  value?: string
  suggested?: string
  allowBlank?: boolean
  onChange: (value?: string) => void
  disabled?: boolean
  highlight?: boolean
  dateMismatch?: boolean
  timeZone: string
}

const TimePicker = ({ value, suggested, allowBlank, onChange, disabled, highlight, dateMismatch, timeZone }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  let displayValue = value ? dayjs(value).tz(timeZone) : undefined;

  if (isOpen && !value && suggested) {
    displayValue = dayjs(suggested)
  }

  return <Space><DatePicker
    value={displayValue}
    mode="date"
    showTime
    format="h:mm A"
    onChange={x => { onChange(x?.toISOString()) }}
    disabled={disabled}
    suffixIcon={<FontAwesomeIcon icon={faClock} />}
    allowClear={allowBlank}
    placement="topRight"
    showNow={false}
    status={highlight ? "warning" : undefined}
    placeholder="Select time"
    onOpenChange={open => setIsOpen(open)}
    onOk={(x) => onChange(x?.toISOString())}
  />
    {dateMismatch === true && <Tooltip title="Date does not match the visit date"><FontAwesomeIcon icon={faCalendar} style={{ color: orange.primary }} /></Tooltip>}
  </Space>
}
export default TimePicker
